import { useItem } from '@/composables/item'
import { propertyManagerService } from '@/services/api'
import { defineStore, acceptHMRUpdate } from 'pinia'

export const usePropertyManagerStore = defineStore('propertyManager', () => {
	const { items, show, itemRemove, getItem } = useItem(
		propertyManagerService,
		'propertymanagers',
		'PropertyManager'
	)

	return { items, show, itemRemove, getItem }
})

if (import.meta.hot) {
	import.meta.hot.accept(
		acceptHMRUpdate(usePropertyManagerStore, import.meta.hot)
	)
}
